import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getActivitiesByCustomerId = async (customerId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/customers/${customerId}/activities`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const getActivities = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/activities`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// api/activityApi.js
export const getAllActivities = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/activities`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const addActivity = async (customerId, activity) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/customers/${customerId}/activities`,
    activity,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateActivity = async (id, activity) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/activities/${id}`, activity, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteActivity = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/activities/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
